<template>
    <div class="open-expenses-container" >
        <div class="columns">
            <div class="column is-4">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Open Expenses</span>
                        <a
                            href="#"
                            class="gear"
                            @click.prevent="isTableSettingsModalActive = true"
                        >
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
        </div>
        <div class="wrapper">
            <o-table
                backend-pagination
                backend-sorting
                class="open-expenses-table fullwidth-table is-responsive is-responsive-desktop"
                v-if="isTableVisible"
                :bordered="table.bordered"
                :checkable="false"
                :data="paginatedData"
                :default-sort="table.defaultSort"
                :loading="loading"
                :mobile-cards="table.mobileCards"
                :narrowed="table.narrowed"
                :paginated="table.paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :striped="table.striped"
                :total="total"

                :selected.sync="selected"
                :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"

                @page-change="onPageChange"
                @sort="onSort"
            >
                <template>
                    <template>
                        <o-table-column
                            v-for="(col, idx) in tableColumns" :key="idx + '_' + col.field"
                            :field="col.field"
                            #default="{ row }"
                            :label="col.label"
                            :sortable="col.sortable"
                        >
                            <dropdown-quick-edit
                                v-if="col.field === 'assigned_to'"
                                :entity="row"
                                field="assigned_to"
                                :update="partialUpdateProjectService"
                                :options="activeUsers"
                            />
                            <router-link v-else-if="col.field === 'project_id'" :to="{ name: 'projects.show.services', params: { slug: row.project_id } }">
                                {{ row.project_id }}
                            </router-link>
                            <router-link v-else-if="col.field === 'project_name'" :to="{ name: 'projects.show.services', params: { slug: row.project_id } }">
                                {{ $filters.valueOrDefault(row.project_name, '-') }}
                            </router-link>
                            <dropdown-quick-edit
                                v-else-if="col.field === 'status'"
                                :entity="row"
                                field="status"
                                :update="partialUpdateProjectService"
                                :options="projectServiceStatuses"
                                :disabled="isStatusDisabled(row)"
                            />
                            <span v-else-if="col.field === 'created_at'" sortable>
                                {{ $filters.datetime(row.created_at) }}
                            </span>
                            <span v-else>
                                {{ $filters.valueOrDefault(row[col.field], '-') }}
                            </span>
                        </o-table-column>
                    </template>
                </template>
                <template #footer>
                    <template v-for="(col, idx) in tableColumns">
                        <th v-if="col.field === 'final_price'" :key="idx">
                            {{ totalsColumns.amountLabel }}
                        </th>
                        <th v-else-if="idx === 0">Totals</th>
                        <th v-else> </th>
                    </template>
                </template>
              <template #empty>
                <div class="has-text-centered">
                  This table is empty!
                </div>
              </template>
            </o-table>
            <div class="grand-total-container">
                <div>
                        <h1>Grand Total:</h1>
                </div>
                <span>
                            {{ $filters.currency(totalAmount) }}
                </span>
            </div>
           <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
                <table-settings-modal :slug="tableName"/>
            </o-modal>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Table from './../../../../mixins/Table'

    export default {
        mixins: [ Table],
        components: {
        },

        computed: {
            ...mapGetters([
                'projectServiceStatuses',
                'users',
            ]),

            activeUsers() {
                return _.filter(this.users, user => ! user.blocked)
                        .map(user => { return { id : user.id, name: user.first_name + ' ' + user.last_name } })
            },

            totalsColumns() {
                const data = this.items,
                currency = this.$filters.currency,
                totalsColumns = { final_price_value: 0, qty: 0 }
                for (let idx = 0; idx < data.length; idx++) {
                    totalsColumns.final_price_value += data[idx].final_price_value || 0
                }
                totalsColumns.amountLabel = currency(totalsColumns.final_price_value)
                return totalsColumns
            },
        },

        created () {
            this.filters = {
                table_view_id: null
            }
        },

        data() {
            return {
                filters: {},
                isTableSettingsModalActive: false,
                isTableVisible: true,
                items: [],
                table: {
                    defaultSort: ['created_at', 'desc'],
                    perPage: 10,
                    perPageOptions: [5, 10, 15, 25, 50],
                },
                tableName: 'open-expenses',
                totalAmount: 0,
                urlFilter: { enabled: false },
                viewAll: false,
            }
        },

        methods: {
            ...mapActions([
                'partialUpdateProjectService',
            ]),

            fetchData(params) {
                return axios.get(`/api/reports/open-expenses-report`, { params })
                    .then(res => {
                        this.items = res.data.data.map(i => ({
                            ...i,
                            final_price: this.$filters.currency(i.final_price),
                            final_price_value: i.final_price,
                        }))
                        this.totalAmount = res.data.totalAmount
                        return res
                    })
            },

            isStatusDisabled(projectService) {
                return projectService.status === 'dropped'
            },

            itemsByIds() {
                return this.items
            },
        },

        mounted() {
            this.filters = { ...this.filtersProp }
            this.fetchPaginatedData()
        },

        props: ['filtersProp'],

        watch: {
            filtersProp: {
                deep: true,
                handler() {
                    this.filters = { ...this.filtersProp }
                    this.fetchPaginatedData()
                }
            },

            data: {
                deep: true,
                handler() {
                    this.fetchPaginatedData()
                }
            },
        },
    }
</script>

<style scoped>
.open-expenses-container {
overflow-x: hidden;
width: 100%; }
.open-expenses-container .modal .modal-card {
  margin: 0 auto; }
.open-expenses-container .open-expenses-table {
  width: 100%; }
  .open-expenses-container .open-expenses-table td.notes ul > li {
    text-align: justify;
    white-space: nowrap; }
  .open-expenses-container .open-expenses-table .table-wrapper {
    min-height: auto;
    overflow-x: auto; }
    .open-expenses-container .open-expenses-table .table-wrapper table {
      white-space: nowrap; }
      .open-expenses-container .open-expenses-table .table-wrapper table th:not(:first-child) > .th-wrap {
        justify-content: center; }
      .open-expenses-container .open-expenses-table .table-wrapper table tbody > tr > td:not(:first-child) {
        text-align: center; }
      .open-expenses-container .open-expenses-table .table-wrapper table tfoot tr th:not(:first-child) {
        text-align: center; }
.open-expenses-container .grand-total-container {
  display: flex; }
  .open-expenses-container .grand-total-container h1 {
    text-transform: uppercase; }
  .open-expenses-container .grand-total-container span {
    margin-left: 15px;
    font-weight: bold; }

</style>